import LoadingSvg from "../../../assets/svg/LoadingSVG";

function LoadingState(): JSX.Element {
  return (
    <div className="py-6 text-center flex justify-center">
      <LoadingSvg isSecondary className="animate-spin" />
    </div>
  );
}

export default LoadingState;

